export const or = (...args: (string | number | boolean | undefined | null)[]): boolean =>
  args.reduce((reducer: boolean, item: any) => {
    if (Boolean(item)) {
      reducer = true;
    }
    return reducer;
  }, false);
